import { MutationTree } from 'vuex';
import { RootState } from '@/store/types';

const mutations: MutationTree<RootState> = {
    showErrMsg(state, msg) {
        state.errMessage = msg
    },
    clearErrMsg(state) {
        state.errMessage = ''
    },
    showInfoMsg(state, msg) {
        state.infoMessage = msg
    },
    clearInfoMsg(state) {
        state.infoMessage = ''
    },
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
};

export default mutations;